import { render } from "./RegistrationCard.vue?vue&type=template&id=6f3ac0a1&ts=true&lang=pug"
import script from "./RegistrationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCard.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__